import React from "react";

export default function MockDataWarning() {
  return (
    null
  );
}
